/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotOrgMetricsResponse {
    getFixupPrototypeFunction() { return CopilotOrgMetricsResponse.fixupPrototype; }

    static newInstance(model: Partial<CopilotOrgMetricsResponse>): CopilotOrgMetricsResponse {
        let obj = Object.assign(new CopilotOrgMetricsResponse(), model);
        CopilotOrgMetricsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotOrgMetricsResponse>): CopilotOrgMetricsResponse {
        if (!model) return null;
        return CopilotOrgMetricsResponse.newInstance(<CopilotOrgMetricsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotOrgMetricsResponse) {
        if (!obj) return;

        models.CopilotOrgMetricsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotOrgMetricsResponse): boolean {
        Object.setPrototypeOf(obj, CopilotOrgMetricsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.org_metrics) {
            models.CopilotOrgMetrics.fixupPrototype(this.org_metrics);
        }
    }

    /**
     * Organization-level Copilot usage metrics
     */
    org_metrics: models.CopilotOrgMetrics;

}
